"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordRequirements = void 0;
var react_1 = __importDefault(require("react"));
var PasswordRequirementsCheck_1 = require("./PasswordRequirementsCheck");
var Box_1 = __importDefault(require("@mui/material/Box"));
var constants_1 = require("../../constants");
var react_i18next_1 = require("react-i18next");
/**
 * Component that renders all of the password requirement line items with check indicators.
 *
 * @param passwordText The string to conduct the complexity checks against
 * @param passwordRequirements Optional requirements to set password
 *
 * @category Component
 */
var PasswordRequirements = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var passwordText = props.passwordText, _a = props.passwordRequirements, passwordRequirements = _a === void 0 ? (0, constants_1.defaultPasswordRequirements)(t) : _a, sx = props.sx, otherProps = __rest(props, ["passwordText", "passwordRequirements", "sx"]);
    return (react_1.default.createElement(Box_1.default, __assign({ sx: sx }, otherProps), passwordRequirements.map(function (req, ind) { return (react_1.default.createElement(PasswordRequirementsCheck_1.PasswordRequirementsCheck, { key: "password_requirement_".concat(ind), label: req.description, isChecked: new RegExp(req.regex).test(passwordText) })); })));
};
exports.PasswordRequirements = PasswordRequirements;
